export const hasRiskReviewValue = (value) => {
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "boolean") return true;
  if (value === 0) return true;
  return value !== undefined && value !== null && String(value).trim() !== "";
};

export const normalizeFieldValueForSubmit = (value, inputType) => {
  if (["NUMBER", "DECIMAL", "CURRENCY", "PERCENTAGE"].includes(inputType)) {
    if (value === "" || value === null || value === undefined) return undefined;
    const next = Number(value);
    return Number.isNaN(next) ? undefined : next;
  }

  return value;
};
